<script>import { getCtx, getAttrs } from "../ctx.js";
const {
  helpers: { isChecked, isIndeterminate }
} = getCtx();
const attrs = getAttrs("indicator");
</script>

<div {...$$restProps} {...attrs}>
	<slot isChecked={$isChecked} isIndeterminate={$isIndeterminate} />
</div>
